module.exports = __webpack_public_path__ + "media/images/game_icon/en/VG0004-0fdf898ac2da6a52d0ef541fe6edf804.png";